import React from "react";
import { BrowserRouter, Route, Routes, Navigate } from "react-router-dom";
import { ThemeProvider, createTheme } from "@mui/material/styles";

import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";

import HomeScreen from "./app/pages/home";
import PolicyScreen from "./app/pages/policy";

import LoginScreen from "./app/pages/login";
import DashboardScreen from "./app/pages/admin/dashboard";

const theme = createTheme({
  palette: {
    primary: {
      main: "#9b5de5",
    },
    secondary: {
      main: "#6979f8",
    },
  },
  typography: {
    fontFamily: '"Poppins", "Roboto", "Helvetica", "Arial", sans-serif',
  },
  components: {
    MuiTextField: {
      styleOverrides: {
        root: {
          "& .MuiOutlinedInput-root": {
            borderRadius: "10px",
            "&:hover fieldset": {
              borderColor: "#9b5de5",
            },
            "&.Mui-focused fieldset": {
              borderColor: "#9b5de5",
            },
          },
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: "50px",
          textTransform: "none",
          fontWeight: 600,
        },
      },
    },
  },
});

function App() {

  return (
    <>
      <ThemeProvider theme={theme}>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<HomeScreen />} />
            <Route path="/login" element={<LoginScreen />} />
            <Route path="/policy" element={<PolicyScreen />} />
            <Route path="/admin-home" element={<DashboardScreen />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
      </ThemeProvider>
    </>
  );
}

export default App;
